export const getMaxLengthCounterText = (currentLength: number, maxLength: number) =>
  `${currentLength} / ${maxLength}`;
